<template>
  <div class="input-group input-group-outline mb-3"
    v-bind:class="{ 'focused is-focused': focused, 'is-filled': value }">
    <label class="form-label">{{ label }}</label>
    <textarea type="text" :value="value" :class="'form-control ' + c_css" :maxlength="maxlength" :minlength="minlength"
      :autocomplete="autocomplete"  @focus="focused = !focused"
      readonly="readonly" :disabled="isBlocked === true"
      @blur="$emit('input', $event.target.value, id)"
      ></textarea>
  </div>
</template>
<!-- @input="$emit('input', $event.target.value, id)" @blur="focused = !focused" --->
<script>
export default {
  props: {
    id: { type: String, required: false, default: '' },
    value: { type: String, required: false, default: '' },
    label: { type: String, required: false, default: '' },
    placeholder: { type: String, required: false, default: '' },
    c_css: { type: String, required: false, default: '' },
    maxlength: { type: String, required: false, default: '' },
    minlength: { type: String, required: false, default: '' },
    autocomplete: { type: String, required: false, default: '' },
    userAdmin: { type: [Number, String], required: false }
  },
  computed: {
    isBlocked() {
      if (this.userAdmin != null && this.userAdmin != 1) {
        return true;
      }
      return false;
    },
  },
  mounted() {
    let input = this.$el.lastElementChild;
    setTimeout(() => {
      input.removeAttribute("readonly");
    }, 500);
  },
  data() {
    return {
      focused: false
    }
  }
}
</script>
<style scoped>
textarea {
  min-height: 200px;
  padding-top: 24px;
  height: auto;
}
</style>